import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RootComponent } from './root.component';
import { AuthorizeGuard } from '../../guards/authorize.guard';
import { AuthenticatedGuard } from '../../guards/authenticated.guard';
import { authorizeCheckFunctions } from '../../authorize-checks';

const childRoutes: Routes = [
  /*{
    path: 'services',
    canActivate: [AuthenticatedGuard, AuthorizeGuard],
    loadChildren: () => import('../services/services.module').then(m => m.ServicesModule),
    data: {
      authorizeCheck: authorizeCheckFunctions.services
    }
  }, TODO: раскомментить, когда будут сервисы*/
  {
    path: 'violations',
    canActivate: [AuthenticatedGuard, AuthorizeGuard],
    loadChildren: () => import('../violations/violations.module').then(m => m.ViolationsModule),
    data: {
      authorizeCheck: authorizeCheckFunctions.violations
    }
  },
  {
    path: 'access-settings',
    canActivate: [AuthenticatedGuard, AuthorizeGuard],
    loadChildren: () => import('../access-settings/access-settings.module').then(m => m.AccessSettingsModule),
    data: {
      authorizeCheck: authorizeCheckFunctions.violations
    }
  },
  {
    path: 'configuration',
    canActivate: [AuthenticatedGuard, AuthorizeGuard],
    loadChildren: () => import('../configuration/configuration.module').then(m => m.ConfigurationModule),
    data: {
      authorizeCheck: authorizeCheckFunctions.violations
    }
  },
  {
    path: 'departments-settings',
    canActivate: [AuthenticatedGuard, AuthorizeGuard],
    loadChildren: () => import('../department-settings/departments-settings.module').then(m => m.DepartmentsSettingsModule),
    data: {
      authorizeCheck: authorizeCheckFunctions.violations
    }
  },

];

const routes: Routes = [
  {
    path: '',
    component: RootComponent,
    children: [
      {
        path: '',
        canActivate: [AuthenticatedGuard],
        loadChildren: () => import('../main-menu/main-menu.module').then(m => m.MainMenuModule),
        data: {
          routesToDisplay: childRoutes,
        }
      },
      ...childRoutes,
    ],
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RootRoutingModule {
}
